import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodRecipet } from "../../assets/Podcast/PodRecipet";
import { gql, useQuery } from "@apollo/client";
import { LoadingWLogo } from "../../components/LoadingWLogo";
import { PodCredit } from "../../assets/Podcast/PodCredit";
import { TextBtn } from "../../components/inputs/TextBtn";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { formatPrice } from "../../components/helper/Price";
import { DashAdd } from "../../assets/Menu/DashAdd";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    .empty {
      margin: 1rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      .title {
        font-size: 2rem;
        font-weight: 700;
      }
      .details {
        font-size: 1.2rem;
      }
    }
    .contract {
      padding: 0.7rem 1rem;
      display: flex;
      box-shadow: 0px 4px 8px -2px #00000040;
      border-radius: 4px;
      text-decoration: none;
      color: inherit;
      transition: all 0.2s ease-in-out;
      :hover {
        background-color: #00000010;
      }
      .expand {
        flex-grow: 1;
      }
      .date {
        width: 25%;
      }
      .more-info {
        color: blue;
        cursor: pointer;
      }
      &.header {
        font-weight: 700;
        :hover {
          background-color: inherit;
        }
      }
    }
  }
`;


export const getCredits_Query = gql`
  query CreditsQuery{
    getCredits {
      _id
      User
      type
      amount
      installment
      time
      payed
      status
    }
  }
`

function WorkPageCredit(props) {
  const history = useHistory();
  const credit = useQuery(getCredits_Query, {
    fetchPolicy: "network-only"
  });
  if(credit.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
            <div className="title">
              <div className="icon"><PodCredit/></div>
              <div className="text">Shopping Credit</div>
            </div>
        </div>
        <div className="content">
          <LoadingWLogo/>
        </div>
      </StyleCss>
    )
  }
  const getEmpty = () => {
    if(credit.data.getCredits.length === 0){
      return (
        <div className="empty">
          <div className="title">
            no credit
          </div>
          <div className="details">
            <TextBtn
              type={"button"}
              text={"request a new credit"}
              onclick={() => {
                history.push("/work/credit/new")
              }}
              loading={false}
              disabled={false}
            />
          </div>
        </div>
      )
    }
    let data = credit.data.getCredits;
    return (
      <>
        <div className="contract header">
          <div className="date">Date</div>
          <div className="date">Shop</div>
          <div className="date">Installments</div>
          <div className="">Amount</div>
          <div className="expand"></div>
          <div className="">Status</div>
        </div>
        {data.map((v, i) => {
          let newDate = (new Date(v.time*1000))
          return (
            <div className="contract" key={i}>
              <div className="date">{newDate.getFullYear()}/{newDate.getMonth()}/{newDate.getDate()}</div>
              <div className="date">{v.type}</div>
              <div className="date">{v.installment}</div>
              <div className="">{formatPrice(v.amount)}</div>
              <div className="expand"></div>
              <div className="">{statusData[v.status]}</div>
            </div> 
          )
        })}
      </>
    )
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodCredit/></div>
            <div className="text">Shopping Credit</div>
          </div>
          <Link
            className="action" 
            to={"/work/credit/new"}
          >
            <DashAdd/>
          </Link>
      </div>
      <div className="content">
        {getEmpty()}
      </div>
    </StyleCss>
  )
}
export default WorkPageCredit;


const statusData ={
  0: "rejected",
  1: "not confirmed",
  2: "confirmed",
}
